﻿import { Component, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { AuthRejectShipDto } from 'src/app/dtos/auth-reject-ship-dto';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'auth-reject',
    templateUrl: './auth-reject.component.html',
    styleUrls: ['./auth-reject.component.scss']
})

export class AuthRejectComponent {

    @ViewChild("tableChild") tableChild: DataTableComponent<AuthRejectShipDto>;
  pagePath: string = "api/ship/getAuthsReject";
  search: any;
  options = {
    columnTitles: ["AUTHREJECT.TABLE.ID", "AUTHREJECT.TABLE.USERNAME", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'username', "actions"],
    actionButtons: { edit: true, delete: true }
  };
  searchText: string = '';

    constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

    }

    goToEdit(e: any) {
        this.router.navigate(["authReject/edit", e.id]);
      }
    
      openDeleteDialog(e: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '680px',
          data: {
            title: 'DIALOGS.DELETE_AUTHREJECT.TITLE',
            body: 'DIALOGS.DELETE_AUTHREJECT.BODY',
            cancelButtonText: "GENERAL.LABELS.CANCEL",
            confirmButtonText: "GENERAL.LABELS.DELETE",
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.apiService.delete('api/ship/deleteAuthReject/' + e.id).subscribe(data => {
              this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "AUTHREJECT.MESSAGES.REMOVED");
              this.tableChild.loadPage();
            }, error => {
              this.messageService.error("Error", error.message);
            })
          }
        });
      }
    
      searchAuthReject(){
        this.search = {
          searchText: this.searchText
        }
        this.tableChild.firstPage();
        this.tableChild.loadPage(this.search);
      }
}